import React, { ReactNode } from 'react'
import { Grid, CircularProgress, Typography } from '@mui/material'
import Button from '@mui/material/Button'

interface ConfirmActionProps {
  handleSubmitAction: any
  handleCloseModal: any
  confirmTitle: string
  confirmText: string
  negateText: string
  isLoading?: boolean
  confirmHeaderText?: string
  disabledConfirm?: boolean
  children?: ReactNode
}

export const ConfirmAction: React.FC<ConfirmActionProps> = ({
  handleSubmitAction,
  handleCloseModal,
  confirmTitle,
  confirmText,
  negateText,
  isLoading,
  confirmHeaderText,
  disabledConfirm = false,
  children
}) => {
  return (
    <Grid container spacing={2}>
      {confirmHeaderText && (
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <Typography variant='h3'>{confirmHeaderText}</Typography>
        </Grid>
      )}
      {confirmTitle && (
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <Typography variant='h6'>{confirmTitle}</Typography>
        </Grid>
      )}
      {children && (
        <Grid item xs={12}>
          {children}
        </Grid>
      )}
      <Grid item xs={6} container justifyContent='center'>
        <Button
          variant='outlined'
          color='primary'
          onClick={handleCloseModal}
          disabled={isLoading}
        >
          {negateText}
        </Button>
      </Grid>
      <Grid item xs={6} container justifyContent='center'>
        <Button
          variant='contained'
          color='primary'
          onClick={handleSubmitAction}
          startIcon={isLoading ? <CircularProgress size='0.9rem' /> : undefined}
          disabled={isLoading || disabledConfirm}
        >
          {confirmText}
        </Button>
      </Grid>
    </Grid>
  )
}
